import constants from "../../../constants";
import Profile from "../Home/LandingPage/Profile";
import { getDataFromStorage } from "../../../util";
import ModuleHooks from "../../../Hooks/ModuleHooks";
import SandpackAssignment from "./SandpackAssignment";
import HeaderHooks from "../Header/Hooks/HeaderHooks";
import SandPackEditorTools from "./SandPackEditorTools";
import RecommendedWebsites from "./RecommendedWebsites";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { SandpackProvider } from "@codesandbox/sandpack-react";
import Loading from "../../Notification-Loading/Loading/Loading";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import React, { memo, useContext, useEffect, useState, useRef } from "react";
import SandPackEditorHooks from "../../../Hooks/SandPackEditorHooks";

export default memo(function SandPackEditor(Props) {
  const Alert = useContext(AlertContext);

  const {
    isAdmin,
    isLoaded,
    testData,
    lpConfigId,
    camAvailable,
    isFullScreensp,
    setCamAvailable,
    showInstructions,
    allWindowsBlurred,
    setShowInstructions,
    openSandpackEditor,
    setShowNotify,
    setOpenSandpackEditor,
    contentData
  } = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const SandPackEditorHks = SandPackEditorHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();
  
  const { electronAPI } = window;

  const focusOutSec = useRef(0);
  const focusOutTimer = useRef(null);

  const [startTime, setStartTime] = useState(null);

  const currentDueLabel = (date) => {
    const dueDate = new Date(date);
    const currentDate = new Date();
    const timeDifference = dueDate.getTime() - currentDate.getTime();
    const dayDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

    if (dayDifference === 0) {
      return "Due Today";
    } else if (
      dayDifference === 1 ||
      (dayDifference === 0 && dueDate !== currentDate)
    ) {
      return "Due Tomorrow";
    } else if (dayDifference < 0) {
      return "Past Due";
    } else {
      return "Upcoming";
    }
  };

  const onFocus = () => {
    if (!allWindowsBlurred.current || !electronAPI) {
      focusOutSec.current = 0;
    }
    if (!electronAPI) {
      clearInterval(focusOutTimer.current);
    }
    if (electronAPI) {
      allWindowsBlurred.current = false;
    }
    window.removeEventListener("blur", onBlur);
  };

  const onBlur = () => {
    focusOutTimer.current = setInterval(() => {
      if (document.visibilityState === 'visible') return;
      let second = focusOutSec.current;

      if (second === 10) {
        console.log("Check ");
        
        clearInterval(focusOutTimer.current);
        SandPackEditorHks.closeAssignment();
      } else if (allWindowsBlurred.current || !electronAPI) {
        second++;
        focusOutSec.current = second;
      }
    }, 1000);
  };

  useEffect(() => {
    if (
      !isAdmin &&
      Props.status !== constants.PROGRESS_STATUS.EVALUATED &&
      testData.proctored !== constants.PROCTORING_MODE.NONE && contentData?.switchedcount<10 && 
      (currentDueLabel(testData.duedate) !== "Past Due" ||
        localStorage.getItem("batchType") == constants.BATCH_TYPE.SELF)
    ) {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);

      return () => {
        window.removeEventListener("blur", onBlur);
        window.removeEventListener("focus", onFocus);
        clearInterval(focusOutTimer.current);
      };
    }
  }, [onBlur]);

  useEffect(() => {
    let role = getDataFromStorage("role");
    console.log("Status:",Props.status);
    if (
      role === constants.Roles.learner &&
      ![
        constants.PROGRESS_STATUS.EVALUATED,
      ].includes(Props.status) 
         &&
      (allWindowsBlurred.current || !electronAPI)
    ) {
      const newStartTime = Date.now();

      let storedTime;
      let learnerId = getDataFromStorage("learnerid");
      console.log("Stored time before api call:", storedTime);

      async function duration() {
        let response = await axios.get(
          `node/learner/content/timespent/${learnerId}/${lpConfigId}`,
          useCommonFunctionHks.getHeaderDetailsForAxios()
        );
        console.log("Api Response:", response);
        storedTime = response?.data?.data?.duration;
        storedTime = storedTime * 1000 * 60;
        console.log("Stored time after lp api call:", storedTime);
        setStartTime(newStartTime);
      }

      duration();

      // When component unmounts

      return () => {
        async function save() {
          const endTime = Date.now();

          let timeSpent =
            endTime - newStartTime + (storedTime ? storedTime : 0);
          timeSpent = Math.round(timeSpent / (60 * 1000));

          console.log("timeSpent:", timeSpent);

          let learnerId = getDataFromStorage("learnerid");
          let requestData = {
            duration: timeSpent,
            learnerid: learnerId,
            lpconfigid: lpConfigId,
          };

          console.log("Time update api is calling..");
          
          let response = await axios.post(
            `node/learner/content/timespent`,
            requestData,
            useCommonFunctionHks.getHeaderDetailsForAxios()
          );
          console.log("Second api respone:", response);
        }

        if (
          role === constants.Roles.learner &&
          ![
            constants.PROGRESS_STATUS.EVALUATED ,
          ].includes(Props.status) &&
          (allWindowsBlurred.current || !electronAPI)
        ) {
          save();
        }
      };
    }
  }, []);

  const checkDisplayCount = async () => {
    let count = await window?.electronAPI?.sendScreenInfo();

    if (count?.monitors && count.monitors > 1) {
      setShowNotify({
        show: true,
        msg: "You are connected to more than one displays. Please detach external display to continue.",
        title: "Warning",
      });

      return;
    }
  };

  useEffect(() => {
    let isMounted = true;

    const checkDisplayCountWithDelay = async () => {
      while (isMounted) {
        await checkDisplayCount();
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    };

    checkDisplayCountWithDelay();

    return () => {
      isMounted = false;
    };
  }, []);

  console.log("testData:",testData);
  console.log("status:",Props.status);
  
  console.log("contentData:",contentData);
  console.log("batchtype", localStorage.getItem("batchType"));
  console.log("condition.....",!isAdmin &&
          Props.status !== constants.PROGRESS_STATUS.EVALUATED &&
          testData.proctored === constants.PROCTORING_MODE.TAB_CAM && contentData?.switchedcount<10 && 
          (currentDueLabel(testData.duedate) !== "Past Due" ||
            localStorage.getItem("batchType") == constants.BATCH_TYPE.SELF));
  
  
  
  return (
    <>
      {Alert.openRecommendedList && (
        <div className="recommendedwebsitescont">
          <RecommendedWebsites />
        </div>
      )}
      {
        <div className="recommendedwebsitescont">
          <SandpackAssignment
            name={Alert.testData.libname}
            showAssignmentInstructions={showInstructions}
            setShowAssignmentInstructions={setShowInstructions}
            description={Alert.assignmentTestData.description}
          />
        </div>
      }
      <div
        className={
          isFullScreensp
            ? "sandpackEditorContainer1"
            : "sandpackEditorContainer2"
        }
      >
        {!isAdmin &&
          Props.status !== constants.PROGRESS_STATUS.EVALUATED &&
          testData.proctored === constants.PROCTORING_MODE.TAB_CAM && contentData?.switchedcount<10 && 
          (currentDueLabel(testData.duedate) !== "Past Due" ||
            localStorage.getItem("batchType") == constants.BATCH_TYPE.SELF) && (
            <div className="profileSandpack">
              <Profile
                type="verfypic"
                questionid={lpConfigId}
                camAvailable={camAvailable}
                isTakeTest={Alert.isTakeTest}
                setCamAvailable={setCamAvailable}
                libtypeid={constants.libTypeIds.ASSIGNMENT}
              />
            </div>
          )}
        {isLoaded && <Loading />}
        <SandpackProvider
          template={Props.selectedTemplate?.value?.toLowerCase()}
          options={{
            autorun: false,
            autoReload: false,
            showConsole: false,
          }}
        >
          <SandPackEditorTools
            status={Props.status}
            focusOutSec={focusOutSec}
            learnerId={Props.learnerId}
            libDetails={Props.libDetails}
            isqueReport={Props.isqueReport}
            template={Props.selectedTemplate}
            isAddSubmission={Props.isAddSubmission}
            openSandpackEditor={openSandpackEditor}
            setOpenSandpackEditor={setOpenSandpackEditor}
          />
        </SandpackProvider>
      </div>
    </>
  );
});
